import React, { useState, useEffect } from "react";
import { connect, useDispatch } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";

//ANT DESIGN IMPORTS
import {
  Input,
  Row,
  Typography,
  Card,
  Spin,
  Form,
  Divider,
  Col,
  Alert,
} from "antd";

//PROJECT IMPORTS
import TopContent from "../../../components/layouts/TopContent";
import { BOM } from "../../../services/definedMethod";
import cnt from "../../../services/definedConstant";

import "../../../assets/styles/DatePicker.css";
import MainLayout from "../../../components/layouts/MainLayout";
import RecordStatus from "../../../components/RecordStatus";
import { apiConfig, labelConfig, staticConfig } from "./interestRate.config";

const { Text, Title } = Typography;

const DetailInterestRate = (props) => {
  //DECLARED VARIABLES
  const { userData } = props;
  const { session } = userData;
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { state } = useLocation();
  const [useForm] = Form.useForm();
  const [interestRateDetail, setInterestRateDetail] = useState({});
  const [inputField, setInputField] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    getDetailById();
  }, []);

  const getDetailById = () => {
    setIsLoading(true);

    const url = `${apiConfig.Floatingrates}/${state.id}`;

    let body = {
      session,
    };

    /** FETCH ROLE */
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
        setIsLoading(false);
      } else {
        const objDetail = res;
        setInterestRateDetail(objDetail);
        setIsLoading(false);

        setInputField([
          {
            name: labelConfig.floatingRateId,
            value: objDetail.id,
          },
          {
            name: labelConfig.floatingRateName,
            value: objDetail.name,
          },
          {
            name: labelConfig.isBaseLendingRate,
            value: objDetail.isBaseLendingRate ? "Yes" : "No",
          },
          {
            name: labelConfig.status,
            value: objDetail.isActive ? "Active" : "Inactive",
          },
        ]);
        setIsLoading(false);
      }
    });
  };

  return (
    <MainLayout isEnableRightSidebar={true}>
      {/* PART 1  IMPORT TOP CONTENT*/}
      <TopContent
        pageTitle={labelConfig.floatingRateDetail}
        pageItems={
          state.variant
            ? staticConfig.viewFloatingRateBreadCrumbItems
            : staticConfig.detailFloatingRateItems
        }
      />

      <Spin spinning={isLoading} size="large">
        <Card
          headStyle={{ borderBottomWidth: 0 }}
          style={{
            boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
            borderRadius: 20,
          }}
        >
          <Form
            form={useForm}
            layout="vertical"
            style={{ paddingTop: 20, marginBottom: 50 }}
          >
            <Row>
              <Divider orientation="left" orientationMargin="0">
                {labelConfig.generalInfo}
              </Divider>
              {inputField.map((item, index) => (
                <Col span={6} style={{ padding: "0px 8px" }} key={index}>
                  <Form.Item label={<Text strong>{item.name}</Text>}>
                    <Input disabled 
                    className="of-bold-disable-input" 
                    value={item.value} />
                  </Form.Item>
                </Col>
              ))}
            </Row>
            <Row>
              <Divider orientation="left" orientationMargin="0">
                {labelConfig.floatingRatePeriodInfo}
              </Divider>

              {interestRateDetail?.ratePeriods?.length === 0 && (
                <Col span={24} style={{ padding: "0px 8px" }}>
                  <Alert
                    message="No Floating Rate Period available"
                    type="warning"
                  />
                </Col>
              )}
              </Row>
              {interestRateDetail?.ratePeriods?.map((item, index) => (
                <Row key={index}>
                  <Col span={8} style={{ padding: "0px 8px" }}>
                    <Form.Item
                      label={<Text strong>{labelConfig.fromDate}</Text>}
                    >
                      <Input
                        disabled 
                        className="of-bold-disable-input"

                        value={BOM.FormatArrayDate(item.fromDate)}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={8} style={{ padding: "0px 8px" }}>
                    <Form.Item
                      label={<Text strong>{labelConfig.floatingRate}</Text>}
                    >
                      <Input disabled 
                      className="of-bold-disable-input" 
                      value={item.interestRate} />
                    </Form.Item>
                  </Col>
                  <Col span={8} style={{ padding: "0px 8px" }}>
                    <Form.Item
                      label={<Text strong>{labelConfig.isDifferential}</Text>}
                    >
                      <Input
                        disabled 
                        className="of-bold-disable-input"

                        value={
                          item.isDifferentialToBaseLendingRate ? "Yes" : "No"
                        }
                      />
                    </Form.Item>
                  </Col>
                </Row>
              ))}
          </Form>
        </Card>

        <RecordStatus
          authStatus={""}
          makerID={""}
          makerDate={""}
          checkerID={""}
          checkerDate={""}
        />
      </Spin>
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
});
const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(DetailInterestRate);
